const examples = {
   "searchResult": {
      id: 1,
      "articles": [
         {
            "title": "Poliitikko Seppo Suhmuri epäiltynä rahanpesusta",
            "summary": "Suhmurilla epäillään olevan yhteyksiä kansainvälisiin veroparatiiseihin, joiden kautta hän on piilottanut miljoonia euroja. Poliisi tutkii useita ulkomaisia tilejä ja yrityksiä.",
            "date": "2024-06-15",
            "brand": "Lehti"
         },
         {
            "title": "Lahjontasotku Suhmurin kiinteistökehityshankkeissa",
            "summary": "Uudet asiakirjat paljastavat, että Suhmuri on hyväksynyt satojatuhansia euroja lahjuksia poliittisissa päätöksissä.",
            "date": "2024-07-20",
            "brand": "Lehti"
         },
         {
            "title": "Sijoitushuijauksen uhrit vaativat oikeutta",
            "summary": "Kultareuna Capitalin huijauksen uhrit vaativat korvauksia yli 50 sijoittajan menettämistä varoista. Suhmuri on kiistänyt syytökset.",
            "date": "2024-09-10",
            "brand": "Lehti"
         },
         {
            "title": "Seppo Suhmuri: Kiristys ja poliittiset väärinkäytökset",
            "summary": "Useat poliitikot ovat tulleet esiin syyttäen Suhmuria kiristyksestä ja uhkailusta liittyen heidän yksityiselämäänsä.",
            "date": "2024-10-05",
            "brand": "Lehti"
         },
         {
            "title": "Suhmurin luksuselämä paljastui – epäillään kavalluksista",
            "summary": "Tutkinnassa on käynyt ilmi, että Suhmuri on käyttänyt valtion varoja yksityisiin luksusmatkoihin ja kiinteistöhankintoihin.",
            "date": "2024-11-12"
         },
         {
            "title": "Suhmurin offshore-tilit tutkinnassa",
            "summary": "Vuodetut pankkitiedot osoittavat, että Suhmurilla on yli 15 miljoonaa euroa hallussaan Caymansaarilla.",
            "date": "2024-12-02"
         },
         {
            "title": "Seppo Suhmurin vaalirahoitus epäilyksen alla",
            "summary": "Suhmurille vaalikampanjaan annetut lahjoitukset ovat peräisin epäilyttävistä lähteistä, mukaan lukien ulkomaiset liikemiehet.",
            "date": "2025-01-18"
         },
         {
            "title": "Entiset avustajat todistavat Suhmuria vastaan",
            "summary": "Suhmurin entiset työntekijät ovat astuneet esiin ja paljastaneet järjestelmällisiä väärinkäytöksiä hänen johdollaan.",
            "date": "2025-02-14"
         },
         {
            "title": "Suhmuri ja tekaistut sopimukset – miljardeja kadoksissa",
            "summary": "Valtio on menettänyt miljoonia euroja Suhmurin hyväksymien tekaistujen sopimusten takia.",
            "date": "2025-03-01"
         },
         {
            "title": "Suhmurille uusia syytteitä veronkierrosta",
            "summary": "Uudet asiakirjat paljastavat, että Suhmuri on pimittänyt tulojaan jo yli vuosikymmenen ajan.",
            "date": "2025-03-10"
         },
         {
            "title": "Suhmurin rikoskumppanit paljastuvat",
            "summary": "Tutkinta on laajentunut ja paljastanut useita muita liikemiehiä ja poliitikkoja, jotka ovat mukana Suhmurin verkostossa.",
            "date": "2025-03-18"
         },
         {
            "title": "Väärinkäytöksiä hyväntekeväisyysjärjestöissä",
            "summary": "Suhmuri on käyttänyt hyväntekeväisyysjärjestöjä peitteenä varojen väärinkäytölle ja rahanpesulle.",
            "date": "2025-04-05"
         },
         {
            "title": "Uusi skandaali: Suhmurin vaalitulokseen vaikuttanut ulkopuolinen rahoitus",
            "summary": "Tutkijat epäilevät, että Suhmurin viimeisin vaalivoitto on ollut mahdollinen ulkomailta saatujen varojen ja vaalivilpin ansiosta.",
            "date": "2025-04-20"
         },
         {
            "title": "Suhmurin piilokaupat kaivosyhtiöiden kanssa paljastuivat",
            "summary": "Suhmurin nimissä toimineet yhtiöt ovat saaneet epäilyttävän edullisia kaivosoikeuksia valtion mailla.",
            "date": "2025-05-10"
         },
         {
            "title": "Valtava tietovuoto: Suhmurin pankkitiedot paljastavat laittomia varainsiirtoja",
            "summary": "Suurin Suhmuriin liittyvä tietovuoto tähän mennessä osoittaa laajamittaista rahanpesua ja veronkiertoa.",
            "date": "2025-06-01"
         },
         {
            "title": "Suhmuri yritti vaikuttaa oikeusprosessiin",
            "summary": "Raporttien mukaan Suhmuri on yrittänyt lahjoa tuomareita ja syyttäjiä saadakseen lievemmän tuomion.",
            "date": "2025-06-15"
         },
         {
            "title": "Suhmuri yhdistetty kansainväliseen talousrikollisuuteen",
            "summary": "Interpolin mukaan Suhmurin liiketoimet ovat liittyneet järjestäytyneeseen rikollisuuteen useissa maissa.",
            "date": "2025-07-01"
         },
         {
            "title": "Uudet asiakirjat: Suhmurin perheenjäsenet hyötyneet laittomista sopimuksista",
            "summary": "Suhmurin perheenjäsenet ovat saaneet miljoonien arvoisia sopimuksia ilman avointa kilpailutusta.",
            "date": "2025-07-12"
         },
         {
            "title": "Suhmuri on paennut oikeutta – etsintäkuulutus annettu",
            "summary": "Seppo Suhmuri on kadonnut ennen oikeudenkäynnin alkua, ja hänestä on annettu kansainvälinen etsintäkuulutus.",
            "date": "2025-08-05"
         },
         {
            "title": "Suhmuri pidätetty ulkomailla",
            "summary": "Suhmuri on pidätetty luksushuvilastaan Karibialla ja odottaa luovutusta Suomeen oikeudenkäyntiä varten.",
            "date": "2025-08-20"
         }
      ],
      "chat_session": {
         "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
         "project_id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
         "created_at": "2024-05-24T09:30:48.375Z",
         "updated_at": "2024-05-24T09:30:48.375Z",
         "chat_messages": [
            {
               "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
               "created_at": "2024-05-24T09:30:48.375Z",
               "updated_at": "2024-05-24T09:30:48.375Z",
               "chat_session_id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
               "message_content": "Tuota yhteenveto Seppo Suhmurin talousrikoksista",
               "role": "system"
            },
            {
               "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
               "created_at": "2024-05-24T09:30:48.375Z",
               "updated_at": "2024-05-24T09:30:48.375Z",
               "chat_session_id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
               "message_content": `
# Seppo Suhmurin Rikokset: Yhteenveto

**Nimi:** Seppo Suhmuri  
**Ammatti:** Poliittinen vaikuttaja, liikemies  

### Rikokset ja epäilykset
1. **Rahanpesu ja veronkierto:**  
   - Suhmuri perusti useita ulkomaisia bulvaaniyrityksiä piilottaakseen laittomasti hankittuja varoja.  
   - Hänen arvioidaan siirtäneen yli 10 miljoonaa euroa veroparatiisien kautta vuosina 2015–2021.  

2. **Lahjonta:**  
   - Poliittisen asemansa avulla Suhmuri hankki etuja tukemalla useiden kiinteistökehityshankkeiden läpimenoa, vastineeksi suurista rahalahjoituksista ja "konsultointipalkkioista".  

3. **Sijoitushuijaukset:**  
   - Suhmurin yritys 'Kultareuna Capital' keräsi yksityisiltä sijoittajilta varoja väittäen sijoittavansa ympäristöhankkeisiin, mutta rahat käytettiin henkilökohtaisten luksushankintojen rahoittamiseen.  

4. **Kiristys ja väärinkäytökset:**  
   - Suhmurin epäillään kiristäneen poliittisia vastustajiaan heidän perhetaustojensa ja yksityiselämänsä perusteella saadakseen heidät vetäytymään päätöksenteosta.  

### Oikeustoimet ja nykytilanne
- Vuonna 2024 Suhmuri pidätettiin ja häntä vastaan nostettiin syytteet rahanpesusta, lahjonnasta ja sijoitushuijauksista.  
- Tällä hetkellä oikeudenkäynti on kesken, mutta uudet tiedot viittaavat siihen, että lisää syytteitä saattaa olla tulossa.  
    `,
               "role": "system"
            },
         ]
      }
   },
   "defaultQueries": [
      {
         "title": "Hiihtolomaliikenne vilkastuu – ruuhkia odotettavissa päätieverkolla",
         "summary": "Hiihtolomien alkaessa liikennemäärät kasvavat erityisesti Etelä-Suomen pääteillä. Liikennevirasto kehottaa varaamaan lisäaikaa matkoille ja seuraamaan ajankohtaisia liikennetiedotteita.",
         "date": "2024-02-15",
         "brand": "Lehti"
      },
      {
         "title": "Runebergin päivän kunniaksi leivokset viedään käsistä leipomoissa",
         "summary": "Perinteiset Runebergin tortut ovat jälleen suosittuja helmikuun alussa. Leipomot kertovat myynnin kasvavan vuosittain, ja suosituimmat leivokset myydään loppuun jo ennen iltapäivää.",
         "date": "2022-02-05",
         "brand": "Lehti"
      },
      {
         "title": "Laskiaissunnuntai tuo pulkkamäet täyteen – sääennuste lupaa täydellistä talvikeliä",
         "summary": "Laskiaisen viettäjille on luvassa aurinkoista pakkassäätä. Ulkoilupuistot ja pulkkamäet odottavat vilkasta viikonloppua, ja asiantuntijat muistuttavat liukkauden vaaroista.",
         "date": "2021-02-23",
         "brand": "Lehti"
      },
      {
         "title": "Helmikuun pakkasennätys rikottiin Pohjois-Suomessa",
         "summary": "Pohjois-Suomessa mitattiin vuoden kylmin päivä, kun elohopea laski –38,7 asteeseen. Sääasiantuntijat arvioivat kylmän jakson jatkuvan vielä useita päiviä.",
         "date": "2019-02-12",
         "brand": "Lehti"
      }
   ],
   "defaultQueries2": [
      {
         "title": "Mitä kuuluu sähköpotkulautojen sääntelylle? – Vuodessa tapahtunut yllättäviä käänteitä",
         "summary": "Sähköpotkulautojen turvallisuudesta ja pysäköintiongelmista keskusteltiin kiivaasti vielä viime vuonna. Nyt palaamme aiheeseen ja tarkastelemme, miten sääntely on edennyt ja mitä muutoksia on odotettavissa.",
         "date": "2025-02-10",
         "brand": "Lehti"
      },
      {
         "title": "Hiljaiselon jälkeen: Onko muovipussiverolla ollut vaikutusta ympäristöön?",
         "summary": "Muovipussivero herätti aikanaan runsaasti keskustelua kulutustottumuksista ja ympäristönsuojelusta. Nyt tutkimme, miten veron käyttöönotto on vaikuttanut muovijätteen määrään ja kuluttajien käyttäytymiseen.",
         "date": "2025-02-14",
         "brand": "Lehti"
      },
      {
         "title": "Ruokatrendien unohtunut hitti: Missä mennään hyönteisruoan kanssa?",
         "summary": "Hyönteisruoka nousi otsikoihin muutama vuosi sitten trendikkäänä vaihtoehtona lihalle. Mutta miksi sen suosio hiipui? Palaamme aiheeseen ja selvitämme, miten hyönteisruoka-alan yrityksillä menee nyt.",
         "date": "2025-02-18",
         "brand": "Lehti"
      },
      {
         "title": "5G-hypen jälkeen: Ovatko lupaukset huippunopeuksista toteutuneet?",
         "summary": "5G-teknologian lanseeraus herätti odotuksia mullistavasta yhteysnopeudesta ja älylaitteiden vallankumouksesta. Nyt tarkistamme, miten 5G on muuttanut arkea ja mitä haasteita sen laajentamisessa on kohdattu.",
         "date": "2025-02-22",
         "brand": "Lehti"
      }
   ],
   "defaultQueries3": [
      {
         "title": "Talven kylmät ennätykset helmikuussa 1929 – Suomen historian hyytävimmät viikot",
         "summary": "Helmikuussa 1929 Suomi koki poikkeuksellisen kovan pakkasjakson, jonka aikana mitattiin ennätyslukemia – jopa -50 °C joillakin paikkakunnilla. Miten suomalaiset selvisivät näistä kylmyyden päivistä ilman nykyajan mukavuuksia?",
         "date": "1929-02-07",
         "brand": "Lehti"
      },
      {
         "title": "Ravintolailta vuonna 1955 – Näin suomalaiset juhlivat ennen alkoholilain uudistusta",
         "summary": "Vuonna 1955 Suomessa elettiin tiukkojen alkoholirajoitusten aikaa. Palaamme vanhoihin arkistoihin ja tutkimme, millaista oli viettää iltaa ravintolassa aikana, jolloin anniskelua säädeltiin tarkasti.",
         "date": "1955-02-12",
         "brand": "Lehti"
      },
      {
         "title": "Laskiaisen perinteet vuonna 1880 – pulkkamäkiä, hernerokkaa ja kansanhuveja",
         "summary": "Laskiainen on ollut suomalaisille tärkeä juhla jo vuosisatojen ajan. Mutta millaista oli laskiaisen vietto 1800-luvun lopulla? Arkistolöydöt paljastavat, miten kansa juhli talven taittumista yli 140 vuotta sitten.",
         "date": "1880-02-25",
         "brand": "Lehti"
      },
      {
         "title": "Ensimmäinen televisiolähetys Suomessa helmikuussa 1957 – Näin suomalaiset näkivät liikkuvan kuvan ihmeen",
         "summary": "Helmikuussa 1957 Suomessa tehtiin historiaa, kun ensimmäinen virallinen televisiolähetys esitettiin. Miten katsojat reagoivat uuteen teknologiaan, ja millaisia ohjelmia tuolloin nähtiin?",
         "date": "1957-02-16",
         "brand": "Lehti"
      }
   ]
}

export default examples;